import { JSX } from 'react';
import './button.style.scss';

type ButtonParams = {
  text: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  textColor?: string;
  backgroundColor?: string;
  onClick?: () => void;
  disabled?: boolean;
  defaultStyle?: string;
  icon?: JSX.Element;
};
const Button = ({
  text,
  type,
  textColor,
  backgroundColor,
  onClick,
  disabled,
  defaultStyle,
  icon,
}: ButtonParams) => (
  <button
    style={{ color: textColor, backgroundColor }}
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`${defaultStyle} ${disabled ? ' disabled' : ''}`}
    title={disabled ? 'Veuillez sélectionner au moins deux cultures' : undefined}
  >
    <div>
      {text}
      {icon && icon}
    </div>
  </button>
);

export default Button;
